import React from "react";
import CountryPicker, { DEFAULT_THEME, Flag } from "react-native-country-picker-modal";
import { Modal } from "../index";
import { CountryPickerProps } from "./types";

const CountryPickerWeb = ({
  onSelect,
  filterProps,
  countryCode,
  visible: modalVisible,
  renderFlagButton,
  onClose,
}: CountryPickerProps) => {
  return (
    <>
      <Flag countryCode={countryCode} flagSize={DEFAULT_THEME.flagSize} />
      <Modal visible={modalVisible} hasBorder={false} webStyle={{ minHeight: 480 }}>
        <CountryPicker
          withEmoji
          withFilter
          withFlag
          withFlagButton
          withCallingCode
          withModal={false}
          onSelect={onSelect}
          filterProps={filterProps}
          countryCode={countryCode}
          disableNativeModal={true}
          visible={false}
          theme={DEFAULT_THEME}
          renderFlagButton={renderFlagButton}
          onClose={onClose}
        />
      </Modal>
    </>
  );
};

export default CountryPickerWeb;
